import Image from 'next/image';

interface BlogImageProps {
  src: string; // Relative path in Supabase Storage (e.g., "photo-gallery/article/photo.webp")
  alt: string;
  caption?: string;
  width?: number;
  height?: number;
  priority?: boolean;
  maxWidth?: number;
}

function getPublicUrl(src: string): string {
  const bucket = src.startsWith('photo-gallery/') ? 'photo-gallery' : 'blog-images';
  const storagePath = bucket === 'photo-gallery'
    ? src.replace('photo-gallery/', '')
    : src;
  const baseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  return `${baseUrl}/storage/v1/object/public/${bucket}/${storagePath}`;
}

export function BlogImage({
  src,
  alt,
  caption,
  width = 1200,
  height = 675,
  priority = false,
  maxWidth,
}: BlogImageProps) {
  const optimizedUrl = getPublicUrl(src);

  return (
    <figure style={maxWidth ? { maxWidth, margin: '0 auto' } : undefined}>
      <div className="relative w-full overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
        <Image
          src={optimizedUrl}
          alt={alt}
          width={width}
          height={height}
          className="w-full h-auto"
          priority={priority}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
        />
      </div>
      {caption && (
        <figcaption className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
